// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  shipId: __t.u64().primaryKey().name("ship_id"),
  preset: __t.string(),
  writer: __t.identity(),
  writerRole: __t.string().name("writer_role"),
  epoch: __t.u32(),
  at: __t.timestamp(),
});
